import { getData } from '@/utils/apiTools';
import { City, Country } from '@/models/Geo';

export const getPlatformCountries = async (signal?: AbortSignal): Promise<Country[]> => getData(
  '/basicdata/platform/countries',
  null,
  signal,
);

export const getCountries = async (signal?: AbortSignal): Promise<Country[]> => getData(
  '/basicdata/geodata/countries',
  null,
  signal,
);

export const getCountryCitiesByPostCode = async (
  countryCode: string,
  filter: string,
  signal?: AbortSignal,
): Promise<City[]> => getData(
  `/basicdata/geodata/country/${countryCode}/postalcodes?filter=${encodeURIComponent(filter)}`,
  null,
  signal,
);

export const getCountryCities = async (
  countryCode: string,
  filter: string,
  signal?: AbortSignal,
): Promise<City[]> => getData(
  `/basicdata/geodata/country/${countryCode}/cities?filter=${encodeURIComponent(filter)}`,
  null,
  signal,
);
